module.exports = __webpack_public_path__ + "static/media/globe_grey.40cf4867.svg";